import React, { FC } from 'react';
import styled from '@emotion/styled';
import { IEnrichedProduct } from '$models';
import { isHtml } from '$lib/helpers';
import { RichText } from '$components/elements/rich-text';
import { Text } from '$components/elements/text';
import { ProductWebRef } from '$templates/product-page/product-web-ref';
import { Flex } from '$components/layouts';

type Props = {
    product: IEnrichedProduct;
};

export const Description: FC<Props> = ({ product: selectedProduct }): JSX.Element => {
    const { product } = selectedProduct;
    return (
        <Flex column gap="large">
            {isHtml(product?.description) ? (
                <RichText text={product?.description} noPadding />
            ) : (
                <StyledProductDescription>{product?.description}</StyledProductDescription>
            )}
            {!!selectedProduct.product?.webRefs?.length && (
                <ProductWebRef
                    webRefs={selectedProduct.product?.webRefs}
                    productTitle={selectedProduct.name}
                    columnView
                />
            )}
        </Flex>
    );
};

const StyledProductDescription = styled(Text)(({ theme }) => ({
    ...theme.mixins.useTextStyle('bodyLarge'),
    whiteSpace: 'pre-line',
    lineHeight: '25px',
}));
